var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mv-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 3.99475C2.50137 3.79778 2.58018 3.60926 2.71938 3.46991C2.85859 3.33056 3.04704 3.25157 3.244 3.25H16.756C17.167 3.25 17.5 3.58375 17.5 3.99475V16.0052C17.4986 16.2022 17.4198 16.3907 17.2806 16.5301C17.1414 16.6694 16.953 16.7484 16.756 16.75H3.244C3.04661 16.7498 2.85737 16.6712 2.71787 16.5316C2.57836 16.392 2.5 16.2026 2.5 16.0052V3.99475ZM4 4.75V15.25H16V4.75H4ZM10 10.1275V5.5H13.75V7H11.5V12.25C11.4997 12.7276 11.3475 13.1927 11.0654 13.578C10.7833 13.9633 10.3859 14.2489 9.93069 14.3934C9.4755 14.5379 8.98615 14.5338 8.53344 14.3817C8.08074 14.2296 7.68817 13.9374 7.41254 13.5474C7.13692 13.1574 6.99254 12.6898 7.0003 12.2123C7.00806 11.7348 7.16755 11.2721 7.4557 10.8913C7.74384 10.5104 8.1457 10.2311 8.6031 10.0938C9.06051 9.95651 9.54974 9.96831 10 10.1275Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv);
export default __webpack_public_path__ + "static/media/mv.269dcf812cb98b4ca5136241f82cee22.svg";
export { ForwardRef as ReactComponent };